if (document.querySelectorAll("[data-ccm-loader-group]")) {
  import("./modules/ccm19.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".CCMOpener")) {
  import("./modules/ccmOpener.module.js").then((module) => {
    module.init();
  });
}